export enum TieupRequestStatus {
  OnProgress,
  Accepted,
  Rejected,
}
